export const PRODUCTION_ROSTER_COLUMNS = [
  {
    name: 'managerEmpNo',
    options: {
      display: 'excluded'
    }
  },
  {
    name: 'team',
    label: 'Team',
    options: {
      display: true,
      sort: true
    }
  },

  {
    name: 'total',
    label: 'Recruiters',
    options: {
      display: true,
      sort: true
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'team',
  direction: 'asc'
};
